import { API } from 'aws-amplify';

interface SkillContentFilters {
  subject?: string;
  grade?: string;
  app?: string;
  skillCode?: string;
}

export const getSkillContent = async (filters: SkillContentFilters = {}) => {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = 'api/skill-content';
  const response = await API.get(apiName, path, {
    queryStringParameters: {
      subject: filters.subject,
      grade: filters.grade,
      app: filters.app,
      skillCode: filters.skillCode,
    },
  });
  return response;
};
